import { UploadFile } from '@/types/source-modal';
import { UploadFileItem } from './UploadFileItem';

interface SourceUploadModalFilesSidebarProps {
    files: UploadFile[];
    activeFileId: string | null;
    onFileSelect: (fileId: string) => void;
    onFileDelete: (fileId: string) => void;
}

export function SourceUploadModalFilesSidebar({
    files,
    activeFileId,
    onFileSelect,
    onFileDelete,
}: SourceUploadModalFilesSidebarProps) {
    return (
        <div
            className="w-80 flex-shrink-0 flex flex-col"
            style={{ minHeight: 0 }}
        >
            <div className="flex-1 overflow-y-auto pr-2 py-4 scrollbar-hide min-h-0">
                <div className="flex flex-col gap-2">
                    {files.map((file) => (
                        <UploadFileItem
                            key={file.id}
                            uploadFile={file}
                            isActive={file.id === activeFileId}
                            onSelect={() => onFileSelect(file.id)}
                            onDelete={() => onFileDelete(file.id)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
